import { SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import React, { useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CustomFilter } from 'app/ComponentLibrary/Filter';
import { SearchPageIcons } from 'app/ComponentLibrary/Filter/SearchPageIcons';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import {
  selectGridFiltersExpanded,
  selectGridState,
} from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { ModsLinkTasksFilter } from './ModsLinkTaskFilterUtils';
import {
  taskSearchFilterName,
  defaultFilterValues as globalEmptyTaskFilterDefaults,
} from '@AMIEWEB/GlobalSearch/Tasks/SearchUtils';

const useStyles = makeStyles()({
  fillterCollapse: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '3px',
  },
  collapse: {
    paddingTop: '4px',
  },
});

export const ModsLinkTaskSearchFilters = ({
  defaultFilterValues: placementModDefaults,
}: {
  defaultFilterValues?: any;
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { reset } = useFormContext();
  const gridState = useSelector(selectGridState);
  const gridSpecs = useRef(new ModsLinkTasksFilter(t));
  const fields = gridSpecs.current.getTaskFilterSpecs();

  const resetFilter = () => {
    const defaults = placementModDefaults ?? globalEmptyTaskFilterDefaults;

    reset(defaults);

    const targetFilterEntries = Object.entries(defaults);

    dispatch(
      gridStateActions.setFilterAttributes({
        ...gridState.filterAttributes,
        filterObject: targetFilterEntries,
        selectedChipFilters: {},
        associatedGridName: gridState.gridTag,
      }),
    );
    dispatch(gridStateActions.setSelectedChips({}));
  };

  const filtersExpanded = useSelector(selectGridFiltersExpanded);
  const handleChange = () => {
    dispatch(gridStateActions.setFiltersExpanded(!filtersExpanded));
  };

  return (
    <Grid container wrap="nowrap" display="flex">
      <Grid item flex="1 1 auto" className={classes.collapse}>
        <Collapse in={filtersExpanded} collapsedSize={38}>
          <CustomFilter
            fields={fields}
            justifyContent="flex-start"
            version2
            resetBtn
            analytics={{
              caller: t('search.globalSearch.globalSearchFilter'),
              onApply: true,
              properties: {
                category: SearchType.tasks,
              },
            }}
          />
        </Collapse>
      </Grid>
      <Grid item flex="0 0 auto" className={classes.fillterCollapse}>
        <SearchPageIcons
          resetlbutton
          funnelButton
          checked={filtersExpanded}
          onResetForm={() => resetFilter()}
          onAdvancedFilterClick={() => handleChange()}
        />
      </Grid>
    </Grid>
  );
};
